import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import FormBuilder from "../../../../../../shared/components/form-builder/form-builder";
import { IInputTcProductDetails } from "../../../../tc-models/tc-req-dto/input-tc-product.req_dto";
import { useParams } from "react-router-dom";
import { useApi } from "../../../../../../shared/hooks/useApi";
import {
  Option,
  payloadToMap,
} from "../../../../tc-models/tc-req-dto/tc-certified-product-details.req_dto";
import { dtrackItService } from "../../../../tc-service/dtrackit.service";
import { Utills } from "../../../../../../shared/app-configs/utilit";
import { useTransactionCertificateStore } from "../../../../../../store/transaction-certificates.store";

interface InputTcProductDetailsProps {
  formRef: any;
  productData: IInputTcProductDetails;
  setProductData: React.Dispatch<React.SetStateAction<IInputTcProductDetails>>;
}

const InputTcProductDetails: React.FC<InputTcProductDetailsProps> = ({
  formRef,
  productData,
  setProductData,
}) => {
  const [productCategoryCode, setProductCategoryCode] = useState([]);
  const [productDeatilsCode, setProductDetailsCode] = useState([]);
  const { setProductCategoriesStore, setProductDetailCodeStore } =
    useTransactionCertificateStore();
  // const [productOptions, setProductOptions] = useState<Option[]>([]);
  // const { loading, error, executeGet } = useApi();
  // const { TE_ID } = useParams()
  // const fetchProductDetails = async () => {
  //   try {
  //     const response = await executeGet(`get-productandrawmaterial-info`, { tcId: TE_ID });
  //     const result = response?.data.tcProductInformation?.map((detail: { tcProductNo?: string }) => ({ value: detail.tcProductNo ?? "", label: detail.tcProductNo ?? "" })) || [];
  //     setProductOptions(result)
  //     //  const result=payloadToMap(response);
  //     //  setData(result.data);
  //   } catch (err) {
  //     console.error('Failed to fetch TC Base Details:', err);
  //   }
  // }
  // useEffect(() => {
  //   fetchProductDetails()
  // }, [])

  const getProductCategory = async () => {
    try {
      const result: any = await dtrackItService.getProductCategory();

      Utills.cl(`result getProductDetails ${JSON.stringify(result)}`);

      const prdtDetails = result.data.map((t: any) => ({
        value: t.code_1,
        label: `${t.description_1} (${t.code_1})`,
      }));
      Utills.cl(`prdtDetails ${JSON.stringify(prdtDetails)}`);
      setProductCategoryCode(prdtDetails);
      setProductCategoriesStore(prdtDetails);
    } catch (err) {
      Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
    }
  };
  const getProductDetailsCode = async () => {
    try {
      const result: any = await dtrackItService.getProductDetailsCode();

      Utills.cl(`result getProductDetails ${JSON.stringify(result)}`);

      const prdtDetails = result.data.map((t: any) => ({
        value: t.code_1,
        label: `${t.description_1} (${t.code_1})`,
      }));
      Utills.cl(`prdtDetails ${JSON.stringify(prdtDetails)}`);
      setProductDetailsCode(prdtDetails);
      setProductDetailCodeStore(prdtDetails);
    } catch (err) {
      Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
    }
  };
  useEffect(() => {
    getProductCategory();
    getProductDetailsCode();
  }, []);

  const formConfig = {
    pageName: "input-tc-product-details",
    initialValues: productData,
    validationSchema: Yup.object().shape({
      inputTcProductNo: Yup.string().nullable(),
      inputTcProductArticleNo: Yup.string()
        .nullable(),
        // .matches(/^[^\s]+$/, "Product Article No. cannot have white spaces"),
      inputTcProductNumberOfUnits: Yup.string()
        .nullable()
        .test(
          "is-exactly-two-decimal-places",
          "Number must be a valid decimal number with upto 2 decimal places.",
          (value: string | null | undefined) => {
            if (!value) return true; // Allow empty values for required validation to handle
            return /^(0|[1-9]\d*|0\.\d{1,2}|[1-9]\d*\.\d{1,2})$/.test(value); // Match exactly two decimal places
          }
        )
        .typeError("Number of Units must be a valid number"),
      inputTcProductUnitsMetric: Yup.string()
        .nullable()
        .test(
          "no-numeric-values",
          "Units Metric must not contain Numbers/Special Characters",
          (value: any) => /^[A-Za-z\s]+$/.test(value)
        ),
             inputTcProductProductionDate: Yup.date().nullable(),
       inputTcProductCategoryCode: Yup.string().nullable(),
       inputTcProductCategoryUserSpecificTerm: Yup.string().nullable(),
       inputTcProductDetailCode: Yup.string().nullable(),
       inputTcProductDetailUserSpecificTerm: Yup.string().nullable(),
    }),
    sections: [
      {
        title: "Input TC Product Details",
        fields: [
          {
            label: "Product No.",
            name: "inputTcProductNo",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            props: {
              placeholder: "Enter TC Product No.",
            },
          },
          {
            label: "Product Article No.",
            name: "inputTcProductArticleNo",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            props: {
              placeholder: "Enter Product Article No.",
            },
          },
          {
            label: "Number of Units",
            name: "inputTcProductNumberOfUnits",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            props: {
              placeholder: "Enter Number of Units",
              type: "number",
            },
          },
          {
            label: "Units Metric",
            name: "inputTcProductUnitsMetric",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            props: {
              placeholder: "Enter Units Metric",
            },
          },
          {
            label: "Production Date",
            name: "inputTcProductProductionDate",
            type: "date",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            props: {
              placeholder: "Select Production Date",
            },
          },
          {
            label: "Product Category Code",
            name: "inputTcProductCategoryCode",
            type: "select",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            props: {
              // helperText: "Enter 'PC9999' when no data available",
              enableSearch: true,
              options: productCategoryCode,
              placeholder: "Select Product Category Code",
              size: "small",
            },
          },
          // {
          //   label: 'Product Category Code',
          //   name: 'inputTcProductCategoryCode',
          //   type: 'text',
          //   gridSize: { xs: 12, md: 4, lg: 4 },
          //  required: false,
          //   props: {
          //     placeholder: 'Enter Product Category Code',
          //   },
          // },
          {
            label: "Category User Specific Term",
            name: "inputTcProductCategoryUserSpecificTerm",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            props: {
              placeholder: "Enter User Specific Term",
            },
          },
          {
            label: "Product Detail Code",
            name: "inputTcProductDetailCode",
            type: "select",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            props: {
              // helperText: "Enter 'PC9999' when no data available",
              enableSearch: true,
              options: productDeatilsCode,
              placeholder: "Select Product Detail Code",
              size: "small",
            },
          },
          // {
          //   label: 'Product Detail Code',
          //   name: 'inputTcProductDetailCode',
          //   type: 'text',
          //   gridSize: { xs: 12, md: 4, lg: 4 },
          //  required: false,
          //   props: {
          //     placeholder: 'Enter Product Detail Code',
          //   },
          // },
          {
            label: "Detail User Specific Term",
            name: "inputTcProductDetailUserSpecificTerm",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            props: {
              placeholder: "Enter Detail User Specific Term",
            },
          },
        ],
      },
    ],
    handleSubmit: (values: any) => {
      Utills.cl("Form Submitted:", values);
      setProductData(values);
    },
  };

  return (
    <>
      <FormBuilder
        formConfig={formConfig}
        onSubmit={formConfig.handleSubmit}
        formRef={formRef}
      />
    </>
  );
};

export default InputTcProductDetails;
